import React, { FC, ReactNode } from 'react'
import { Eye, EyeOff } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '../../../../components/ui/tooltip'

import { cn } from '../../../../lib/utils'

import { IRider } from '../../../../types/entryRider'

interface IProps {
  btnHandler?: ReactNode
  titleAdds?: string | JSX.Element | JSX.Element[]
  title: string
  centered?: boolean
}

export const TableName: React.FC<IProps> = ({ title, btnHandler, titleAdds, centered }) => {
  return (
    <div
      className={`flex items-center  gap-2 text-gray-600 font-normal w-full text-sm ${centered && 'justify-center'}`}
    >
      <span>
        {title} {titleAdds}
      </span>
      {btnHandler}
    </div>
  )
}

interface IssueFieldProps {
  issues: number
  showIssues: boolean
  onClick: () => void
}

export const IssueField: FC<IssueFieldProps> = ({ issues, showIssues, onClick }) => {
  return (
    <div
      className={cn(
        'w-full text-base lg:text-center hover:underline cursor-pointer',
        issues > 0 && showIssues
          ? 'text-SeabiscuitMainThemeColor'
          : 'text-SeabiscuitDark100ThemeColor/50'
      )}
      onClick={onClick}
    >
      {issues > 0 ? issues : 0}
    </div>
  )
}

interface IssuesTableNameProps {
  name: string
  keyName: keyof IRider
  onClick: () => void
  items: IRider[]
}

export const IssuesTableName: FC<IssuesTableNameProps> = ({ name, keyName, onClick, items }) => {
  return (
    <TableName
      centered
      title={name}
      btnHandler={
        <button onClick={onClick}>
          {items.every((item) => item[keyName]) ? (
            <Tooltip>
              <TooltipTrigger asChild>
                <Eye className="w-3.5" />
              </TooltipTrigger>
              <TooltipContent>Hide issues</TooltipContent>
            </Tooltip>
          ) : (
            <Tooltip>
              <TooltipTrigger asChild>
                <EyeOff className="w-3.5" />
              </TooltipTrigger>
              <TooltipContent>Show issues</TooltipContent>
            </Tooltip>
          )}
        </button>
      }
    />
  )
}
